import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`As a package owner or collaborator, if your package has no dependents, you can permanently remove it from the npm registry by using the CLI. You can `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/cli/v7/commands/npm-unpublish"
      }}>{`unpublish`}</a>{` within 72 hours of the initial publish; beyond 72 hours, you can still unpublish your package if `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/policies/unpublish"
      }}>{`it meets certain criteria`}</a>{`.`}</p>
    <p>{`These criteria are set to avoid damaging the JavaScript package ecosystem.  If you cannot unpublish your package, you can `}<a parentName="p" {...{
        "href": "/deprecating-and-undeprecating-packages-or-package-versions"
      }}>{`deprecate it instead`}</a>{`.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` Removing all the collaborators or teams from the package will not unpublish it.`}</p>
    </Note>
    <h2>{`Unpublishing a package`}</h2>
    <p>{`If you want to completely remove all versions of a package from the registry, you can unpublish it completely.  This will delete it from the registry and it will be unable to be installed.`}</p>
    <p>{`To unpublish a package, you must meet the requirements of the `}<a parentName="p" {...{
        "href": "#how-to-unpublish"
      }}>{`package unpublishing rules`}</a>{`.`}</p>
    <h3>{`Using the website`}</h3>
    <ol>
      <li parentName="ol">
        <>{shared["user-login"].text}</>
        <>{shared["user-login"].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Navigate to the package page for the package you want to unpublish, replacing `}<inlineCode parentName="p">{`<your-package-name>`}</inlineCode>{` with the name of your package:
`}<inlineCode parentName="p">{`https://www.npmjs.com/package/<your-package-name>`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Settings`}</strong>{`.`}</p>
        <Screenshot src="/packages-and-modules/securing-your-code/2fa-package-admin.png" alt="Screenshot showing the admin tab on a package page" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under "delete package", click `}<strong>{`Delete package`}</strong>{`.`}</p>
        <Screenshot src="/packages-and-modules/deleting-deprecating/delete-package-settings.png" alt="Screenshot showing the admin tab on a package page" mdxType="Screenshot" />
        <Note mdxType="Note">
          <p parentName="li"><strong parentName="p">{`Note:`}</strong>{` If you cannot delete the package because it does not meet the `}<a parentName="p" {...{
              "href": "#how-to-unpublish"
            }}>{`unpublishing requirements`}</a>{`, then the delete package option will not be available.  Instead, you will be prompted to `}<a parentName="p" {...{
              "href": "/deprecating-and-undeprecating-packages-or-package-versions#deprecating-a-package-from-the-website"
            }}>{`deprecate the package`}</a>{`.`}</p>
        </Note>
      </li>
      <li parentName="ol">
        <p parentName="li">{`If you are sure that you want to continue, enter your package name and click `}<strong>{`Delete package`}</strong>{`.`}</p>
        <Screenshot src="/packages-and-modules/deleting-deprecating/delete-package-confirm.png" alt="Screenshot showing the admin tab on a package page" mdxType="Screenshot" />
      </li>
    </ol>
    <h3>{`Using the command line`}</h3>
    <p>{`To unpublish an entire package, run the following command, replacing `}<inlineCode parentName="p">{`<package-name>`}</inlineCode>{` with the name of your package:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm unpublish <package-name> -f
`}</code></pre>
    <p>{`If you have `}<a parentName="p" {...{
        "href": "about-two-factor-authentication"
      }}>{`two-factor authentication`}</a>{` enabled for writes, you will need to add a one-time password to the `}<inlineCode parentName="p">{`unpublish`}</inlineCode>{` command, `}<inlineCode parentName="p">{`--otp=123456`}</inlineCode>{` (where `}<em parentName="p">{`123456`}</em>{` is the code from your authenticator app).`}</p>
    <>If you need help unpublishing your package, please {shared['contact-support'].text}. If you are an Enterprise customer, please {shared['contact-enterprise-support'].text}</>.
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` If you unpublish an entire package, you may not publish any new versions of that package until 24 hours have passed.`}</p>
    </Note>
    <h2>{`Unpublishing a single version of a package`}</h2>
    <p>{`If you want to remove a single version of a package, you can unpublish one version without affecting the others.   This will delete only that version from the registry and it will be unable to be installed. This option is only available via the npm CLI.`}</p>
    <h3>{`Using the command line`}</h3>
    <p>{`To unpublish a single version of a package, run the following command, replacing `}<inlineCode parentName="p">{`<package-name>`}</inlineCode>{` with the name of your package, and `}<inlineCode parentName="p">{`<version>`}</inlineCode>{` with your version number:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm unpublish <package-name>@<version>
`}</code></pre>
    <h2>{`When to unpublish`}</h2>
    <p>{`Unpublishing a package permanently removes the package from the registry so it is no longer available for other users to install. Once a package is unpublished, republishing under the same name is blocked for 24 hours. If you've unpublished a package by mistake, we'd recommend publishing again under a different name, or for unpublished versions, bumping the version number and publishing again.`}</p>
    <p>{`You might want to unpublish a package because you:`}</p>
    <ul>
      <li parentName="ul">{`Published something accidentally.`}</li>
      <li parentName="ul">{`Wanted to test npm.`}</li>
      <li parentName="ul">{`Published content you `}<a parentName="li" {...{
          "href": "https://blog.npmjs.org/post/101934969510/oh-no-i-accidentally-published-private-data-to"
        }}>{`didn't intend to be public`}</a>{`.`}</li>
      <li parentName="ul">{`Want to rename a package. (The only way to rename a package is to re-publish it under a new name)`}</li>
    </ul>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` `}<inlineCode parentName="p">{`package-name@version`}</inlineCode>{` is unique, and cannot be reused by unpublishing and re-publishing it. We recommend publishing a minor version update instead.`}</p>
    </Note>
    <h2>{`When to deprecate`}</h2>
    <p>{`If you are no longer interested in maintaining a package, but want it to remain available for users to install, or if your package has dependents, we'd recommend `}<a parentName="p" {...{
        "href": "cli/deprecate"
      }}>{`deprecating`}</a>{` it. To learn about how to deprecate a package, see "`}<a parentName="p" {...{
        "href": "deprecating-and-undeprecating-packages-or-package-versions"
      }}>{`Deprecating and undeprecating packages or package versions`}</a>{`".`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      